(function () {
  const root = document.documentElement;

  function getOffset() {
    const headerSection = document.querySelector('#shopify-section-header');
    const header = headerSection ? headerSection.querySelector('header, .header, .header-wrapper') : null;

    const announceSection = document.querySelector('#shopify-section-announcement-bar');
    const announce = announceSection
      ? announceSection.querySelector('.announcement-bar, .utility-bar, .announcement-bar-section')
      : null;

    const headerH = header ? header.getBoundingClientRect().height : 0;
    const announceH = announce ? announce.getBoundingClientRect().height : 0;

    return Math.round(headerH + announceH);
  }

  function applyOffset() {
    root.style.setProperty('--nerra-header-offset', `${getOffset()}px`);
  }

  function initStuckState() {
    const sticky = document.querySelector('.nerra-collection-sticky');
    if (!sticky) return;

    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    sticky.prepend(sentinel);

    const obs = new IntersectionObserver(
      ([entry]) => sticky.classList.toggle('nerra-is-stuck', entry.intersectionRatio < 1),
      { threshold: [1] }
    );
    obs.observe(sentinel);
  }

  applyOffset();
  initStuckState();

  window.addEventListener('resize', applyOffset, { passive: true });
  document.addEventListener('shopify:section:load', applyOffset);
})();